import { SvgIconProps } from '@/types/helpers'

export default function CheckBoxOutline(props: SvgIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      stroke="white"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect
        x="0.75"
        y="0.75"
        width="18.5"
        height="18.5"
        rx="1.25"
        stroke="currentStroke"
        strokeWidth="1.5"
      />
    </svg>
  )
}
